/*
    自定义的格式化方法
*/

/* 表格列数据格式化*/

/**
 * 格式化为带位数小数，默认2位
 * @param value
 * @param fixedDigit
 * @param isErrorR0
 */
export function formatterDecimal(value, fixedDigit, isErrorR0) {
  // 带2位小数的数字
  let result = ''
  if (isErrorR0 === true) {
    result = '0'
  }
  if (value === undefined || value === null || value === '' || isNaN(value)) {
    return result
  } else if (
    fixedDigit === undefined ||
    fixedDigit === null ||
    fixedDigit === '' ||
    isNaN(fixedDigit)
  ) {
    return value.toString()
  } else {
    result = Number(value).toFixed(fixedDigit)
    return result
  }
}

/* 金额转换*/

/**
 * 人民币小写金额转换为大写
 * @param amount
 * @param isDefaultWhenError
 */
export function amountUppercase(amount, isDefaultWhenError) {
  if (amount === undefined || amount === null || amount === '' || isNaN(amount)) {
    if (isDefaultWhenError === true) {
      return '零元整'
    }
    return ''
  }
  const fraction = ['角', '分']
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  const unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']]
  const head = amount < 0 ? '欠' : ''
  amount = Math.abs(amount)
  let s = ''
  for (let i = 0; i < fraction.length; i++) {
    s += (
      digit[
        Math.floor(
          (Math.floor(amount * 1000 * 10 * Math.pow(10, i)) % (10 * 1000)) /
        1000
        )
      ] + fraction[i]
    ).replace(/零./, '')
  }
  s = s || '整'
  amount = Math.floor(amount)
  for (let i = 0; i < unit[0].length && amount > 0; i++) {
    let p = ''
    for (let j = 0; j < unit[1].length && amount > 0; j++) {
      p = digit[amount % 10] + unit[1][j] + p
      amount = Math.floor(amount / 10)
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }
  return (
    head +
    s
      .replace(/(零.)*零元/, '元')
      .replace(/(零.)+/g, '零')
      .replace(/^整$/, '零元整')
  )
}

/* 日期转换*/

/**
 * 日期转换为格式yyyy MM dd
 * @param date
 * @param dateSeparator
 * @param typeEnd 显示到的类型，默认为date，即yyyy MM dd
 */
export function dateFormatToyyyyMMdd(date, dateSeparator, typeEnd) {
  if (date === undefined || date === null || date === '') {
    return ''
  }
  var datetime
  if (typeof date === 'string') {
    datetime = new Date(date)
    if(datetime instanceof Date && isNaN(datetime.getTime())){
      if(date.lastIndexOf('.') >= 10){
        date = date.substring(0, date.lastIndexOf('.'))
      }
      datetime = new Date(date.replace(/-/g,"/"))
    }
  } else {
    datetime = date
  }
  if (!dateSeparator) {
    dateSeparator = '-'
  }
  if (!typeEnd) {
    typeEnd = 'date'
  }
  var year = datetime.getFullYear()
  var month =
    datetime.getMonth() + 1 < 10
      ? '0' + (datetime.getMonth() + 1)
      : datetime.getMonth() + 1
  var date =
    datetime.getDate() < 10 ? '0' + datetime.getDate() : datetime.getDate()
  var hour =
    datetime.getHours() < 10 ? '0' + datetime.getHours() : datetime.getHours()
  var minute =
    datetime.getMinutes() < 10
      ? '0' + datetime.getMinutes()
      : datetime.getMinutes()
  var second =
    datetime.getSeconds() < 10
      ? '0' + datetime.getSeconds()
      : datetime.getSeconds()
  var dateStrNew = ''
  switch (typeEnd) {
    case 'year':
      dateStrNew = year
      break
    case 'month':
      dateStrNew = dateStrNew = year + dateSeparator + month
      break
    case 'date':
      dateStrNew = dateStrNew = year + dateSeparator + month + dateSeparator + date
      break
    case 'hour':
      dateStrNew = dateStrNew = year + dateSeparator + month + dateSeparator + date + ' ' + hour
      break
    case 'minute':
      dateStrNew = dateStrNew = year + dateSeparator + month + dateSeparator + date + ' ' + hour + ':' + minute
      break
    case 'second':
      dateStrNew = dateStrNew = year + dateSeparator + month + dateSeparator + date + ' ' + hour + ':' + minute + ':' + second
      break
  }

  return dateStrNew
}

/**
 * 日期转换为格式yyyy MM dd HH:mm:ss
 * @param date
 * @param dateSeparator
 */
export function dateTimeFormatToyyyyMMddHHmmss(time, dateSeparator) {
  if (time === undefined || time === null || time === '') {
    return ''
  }
  var datetime
  if (typeof time === 'string') {
    datetime = new Date(time)
    if(datetime instanceof Date && isNaN(datetime.getTime())){
      datetime = new Date(time.replace(/-/g,"/"))
    }
  } else {
    datetime = time
  }
  if (!dateSeparator) {
    dateSeparator = '-'
  }
  var year = datetime.getFullYear()
  var month =
    datetime.getMonth() + 1 < 10
      ? '0' + (datetime.getMonth() + 1)
      : datetime.getMonth() + 1
  var date =
    datetime.getDate() < 10 ? '0' + datetime.getDate() : datetime.getDate()
  var hour =
    datetime.getHours() < 10 ? '0' + datetime.getHours() : datetime.getHours()
  var minute =
    datetime.getMinutes() < 10
      ? '0' + datetime.getMinutes()
      : datetime.getMinutes()
  var second =
    datetime.getSeconds() < 10
      ? '0' + datetime.getSeconds()
      : datetime.getSeconds()

  return (
    year + dateSeparator + month + dateSeparator + date + ' ' + hour + ':' + minute + ':' + second
  )
}

/* 税率转换*/

/**
 * 税率转换，带百分号
 * @param taxRate
 * @param fixedDigit
 * @param isRideHundred
 * @param isPerSign
 */
export function taxRateFormatWithPerSign(
  taxRate,
  fixedDigit,
  isRideHundred,
  isPerSign
) {
  let taxRateStr = ''
  if (
    taxRate === undefined ||
    taxRate === null ||
    taxRate === '' ||
    isNaN(taxRate)
  ) {
    return taxRateStr
  }
  if (
    isRideHundred === undefined ||
    isRideHundred === null ||
    isRideHundred.toString().toLowerCase() !== 'false'
  ) {
    isRideHundred = true
  }
  if (
    isPerSign === undefined ||
    isPerSign === null ||
    isPerSign.toString().toLowerCase() !== 'false'
  ) {
    isPerSign = true
  }
  if (
    fixedDigit === undefined ||
    fixedDigit === null ||
    fixedDigit === '' ||
    isNaN(fixedDigit)
  ) {
    fixedDigit = 2
  }

  let taxRateNew = taxRate
  if (isRideHundred) {
    taxRateNew = taxRate * 100
  }
  taxRateStr = formatterDecimal(taxRateNew, fixedDigit)
  if (isPerSign) {
    taxRateStr += '%'
  }

  return taxRateStr
}
